
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "NoImageAvailable",
    props: {
        width: {
            type: [Number, String],
            required: false,
            default: undefined
        },
        height: {
            type: [Number, String],
            required: false,
            default: undefined
        }
    },
    setup(props) {
        const computedWidth = computed(() =>
            props.width ? `${props.width}px` : "100%"
        );
        const computedHeight = computed(() =>
            props.height ? `${props.height}px` : "auto"
        );

        return { ...useI18n(), computedWidth, computedHeight };
    }
});
